import Footer from "../../footer"
import NavBar from "../../nav"

const DigitalSolution = () => {
  return <div className='digital'>
    <NavBar />
    <div>
    <section className="clean-block pfa-content clearfix">
			<div className="divider sections">
				<h1>Our Digital Solutions</h1>
				<div className="headline-divider sections"></div>
				<h2>A properly designed and clearly documented manual system.</h2>
			</div>
		</section>
    <section className="clean-block clearfix">
			<div className="divider sections">Our Core Competency</div>	
			<div className="container content-container about-container">	
				<div className="prose">Our core competency is understanding the regulatory requirements and developing technical publications to unique requirements. Fly Compliant, LLC has been providing manuals to the aviation industry since 1994. We have provided continued support to operations of all sizes, under each operating rule. From printed documents to our electronic delivery system using our LevelFlight application, we are able to provide a standardized system, compliant with applicable regulations.  Our eManuals allows users to navigate quickly by using, bookmarks and links to find information needed. We have invested heavily in technical authoring.</div>
				<div className="prose not-first"><a href="/assets/pdf/Adobe-AirlineCert-Article.pdf" target="_blank" rel="noreferrer">Read the Adobe Case Study about our development process.</a></div>
				<div className="prose not-first">A properly designed and clearly documented manual system is critical to operations. All flight departments must provide personnel with current operating manuals, precisely detailing policies and procedures. Standardization is a benefit of our electronic system. Flight managers will have a method of ensuring all personnel have the same policies and procedures. The result is a functional system with accountability throughout the organization.</div>	
				<div className="prose not-first">Operations must spend time developing relevant documents to operate efficiently. Fly Compliant, LLC is highly experienced with designing functional manuals which will evolve as operations and regulations change. By leveraging our experience and working closely with management the end result will be a detailed manual system providing clear guidance. Our proprietary technology, LevelFlight is another benefit allowing distribution of all publications, efficiently and compliant.</div>	
			</div>
		</section>
    <section className="clean-block clearfix">
			<div className="divider sections">Our Digital Solutions</div>	
			<div className="container content-container solutions-container">	
				<div className="container-fluid">					
					<div className="row">
						<div className="col-sm tiles">
							<div className="header">Manual Systems May Include:</div>
							<div className="content">
								<ul>
									<li>Company Policy Manual (CPM)</li>
									<li>Compliance Statement (SOC)</li>
									<li>Electronic Flight Bag (EFB)</li>
									<li>Electronic Procedures Manual (EPM)</li>
									<li>Flight Attendant Manual (FAM)</li>
									<li>General Maintenance Manual (GMM)</li>
									<li>General Operations Manual (GOM)</li>
									<li>Hazardous Material (HazMat)</li>
									<li><a href="/manuals/international-procedures">International Procedures Manual (IOM)</a></li>
									<li>Landing Procedures (CAT II and IIIb)</li>
									<li>Letter of Authorization (LOA)</li>
									<li>Minimum Equipment List (MEL)</li>
									<li>Reduced Vertical Separation Manual (RVSM)</li>
									<li>Safety Management System (SMS)</li>
									<li>Special Procedures (SP)</li>
									<li>Standard Operating Procedures (SOP)</li>
									<li>Training Program (GTM)</li>
								</ul>
							</div>
						</div>
						<div className="col-sm tiles">
							<div className="header">All of your manuals in one easy to use, easy to read platform.</div>
							<div className="content">
								<div className="feature-image"><img className="levelflight-image" src="/assets/img/_web/manuals/iPad_LevelFlight.png" alt="" /></div>
								<div className="feature-links"><a href="/services/electronic-recordkeeping">Learn more about LevelFlight</a><br /><a href="https://apps.apple.com/us/app/levelflight/id1043813975" target="_blank" rel="noreferrer">Download the App</a></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
    </div>
    <Footer />
  </div>
}

export default DigitalSolution